var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{attrs:{"label-width":"100px","model":_vm.workOrder}},[_c('el-form-item',{attrs:{"label":"状态："}},[_vm._v(" "+_vm._s(_vm.statusEnum[_vm.workOrder.status])+" ")]),_c('el-form-item',{attrs:{"label":"当前承接人："}},[_vm._v(" "+_vm._s(_vm.workOrder.acceptUsers && _vm.workOrder.acceptUsers.map((item) => item.userName).join(","))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }